// extracted by mini-css-extract-plugin
export default {"favorited":"productsDetailHeadRight_favorited__0Ukqc","star":"productsDetailHeadRight_star__XDgle","feedback":"productsDetailHeadRight_feedback__VOf0l"};